import { render, staticRenderFns } from "./UserRegisterForm.vue?vue&type=template&id=2ba08e12"
import script from "./UserRegisterForm.vue?vue&type=script&lang=js"
export * from "./UserRegisterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormSiteInput: require('/opt/atlassian/pipelines/agent/build/components/form/SiteInput.vue').default,FormSiteInputCheckbox: require('/opt/atlassian/pipelines/agent/build/components/form/SiteInputCheckbox.vue').default})
